import { Cookies } from 'react-cookie';

/**
 * Checks if user is authenticated
 */
const isUserAuthenticated = () => {
    const token = getUserAccessToken();
    return !!token;
};

const getLoginId = () => {
    const cookies = new Cookies();
    return cookies.get('loginId');
};

const getLoginData = () => {
    const cookies = new Cookies();
    const loginData = cookies.get('loginData');
    return loginData ? (typeof loginData == 'object' ? loginData : JSON.parse(loginData)) : {};
};

/**
 * Returns the logged in user
 */
const getLoggedInUser = () => {
    const cookies = new Cookies();
    const user = cookies.get('user');
    return user ? (typeof user == 'object' ? user : JSON.parse(user)) : null;
};

const getUserAccessToken = () => {
    const cookies = new Cookies();
    const tokens = cookies.get('tokens');
    return tokens ? (typeof tokens == 'object' ? tokens.access : JSON.parse(tokens).access) : null;
};

/**
 * Logout function to clear all authentication data
 * @param {string} message - Optional message to display on login page (e.g., session expiration)
 */
const logout = (message = null) => {
    const cookies = new Cookies();
    cookies.remove('user', { path: '/' });
    cookies.remove('tokens', { path: '/' });
    cookies.remove('loginId', { path: '/' });
    cookies.remove('loginData', { path: '/' });
    // Clear any other auth-related cookies
    Object.keys(cookies.getAll()).forEach(key => {
        if (key.includes('loginData_') || key.includes('auth')) {
            cookies.remove(key, { path: '/' });
        }
    });
    
    // Store logout message in sessionStorage to display on login page
    if (message) {
        sessionStorage.setItem('logoutMessage', message);
    }
    
    window.location.href = '/account/login';
};

export { isUserAuthenticated, getLoggedInUser, getUserAccessToken, getLoginId, getLoginData, logout };
